import React from "react";

const SectionHeading = (props) => {
  return (
    <>
      <div className="row" id="flight_search_result_for_scrolling">
        <div className="col-lg-12 col-md-12 col-sm-12 col-12">
          <div className="section_heading_center">
            <h2>{props.heading}</h2>
          </div>
        </div>
      </div>
    </>
  );
};

export default SectionHeading;
